import { render } from "./MileForm.vue?vue&type=template&id=87e575d0"
import script from "./MileForm.vue?vue&type=script&lang=js"
export * from "./MileForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__